import React from "react";
import { t } from "i18next";
import SFRadioGroup from "../../../radioGroup";

const BooleanRenderer = ({
  config,
  generatedFilter,
  colDef,
  colId,
  onChange,
}) => {
  const selectedValues = generatedFilter?.values ?? [];

  const handleChange = (e) => {
    if (config.loading) return;

    const value = e.target.value;
    if (value === "") {
      onChange([]);
    } else {
      onChange([value]);
    }
  };

  // The label for the option to clear the filter for this field
  const selectAllLabel =
    colDef.filterParams?.allLabel ?? t("components.datagrid.filters.allLabel");

  const RADIOS = [
    {
      label: selectAllLabel,
      value: "",
    },
    ...config.displayValues.map((displayValue) => ({
      label: colDef.valueFormatter
        ? colDef.valueFormatter({ value: displayValue })
        : displayValue,
      disabled: !config.values.some(
        (value) =>
          (typeof value === "boolean" ? value.toString() : value) ===
          displayValue
      ),
      value: displayValue,
    })),
  ];

  // The currently selected value
  const selectedValue = selectedValues.length > 0 ? selectedValues[0] : "";

  return (
    <SFRadioGroup
      name={colId}
      radios={RADIOS}
      value={selectedValue}
      onChange={handleChange}
    />
  );
};

export default BooleanRenderer;
